import { Link, useLocation } from "react-router-dom";
import { ListChecks, FileText, Images, Armchair, LogOut, ExternalLink, Music } from "lucide-react";

export const AdminHeader = ({ onLogout }) => {
  const loc = useLocation();
  const tabs = [
    { to: "/admin", label: "Zusagen", icon: ListChecks, exact: true },
    { to: "/admin/content", label: "Inhalte", icon: FileText },
    { to: "/admin/gallery", label: "Galerie", icon: Images },
    { to: "/admin/seating", label: "Tischplan", icon: Armchair },
    { to: "/admin/music", label: "Musik", icon: Music },
  ];
  const active = (t) => (t.exact ? loc.pathname === t.to : loc.pathname.startsWith(t.to));

  return (
    <header data-testid="admin-header" className="bg-white border-b border-sage-200 sticky top-0 z-20">
      <div className="container mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between gap-6">
        <div className="min-w-0">
          <div className="font-serif text-xl md:text-2xl text-sage-800 truncate">
            Admin · Nico &amp; Nicole
          </div>
          <p className="text-[11px] text-sage-500 tracking-wide">01.08.2026 · Gut Haferkorn</p>
        </div>
        <nav className="hidden md:flex items-center gap-1 bg-sage-50 border border-sage-200 rounded-full p-1">
          {tabs.map((t) => {
            const Icon = t.icon;
            const isActive = active(t);
            return (
              <Link
                key={t.to}
                to={t.to}
                data-testid={`admin-tab-${t.to.split("/").pop() || "home"}`}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs uppercase tracking-wide transition-all ${
                  isActive
                    ? "bg-sage-500 text-white shadow-sm"
                    : "text-sage-700 hover:bg-sage-100"
                }`}
              >
                <Icon size={14} />
                {t.label}
              </Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-2">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sage-600 hover:text-sage-800 text-xs px-3 py-2"
          >
            <ExternalLink size={14} />
            <span className="hidden sm:inline">Website</span>
          </a>
          {onLogout && (
            <button
              data-testid="admin-logout-btn"
              onClick={onLogout}
              className="inline-flex items-center gap-1 rounded-full bg-sage-500 hover:bg-sage-600 text-white px-3 md:px-4 py-2 text-xs uppercase tracking-wide"
            >
              <LogOut size={14} />
              <span className="hidden sm:inline">Ausloggen</span>
            </button>
          )}
        </div>
      </div>

      {/* Mobile tabs */}
      <nav className="md:hidden flex items-center gap-1 px-4 py-2 bg-sage-50 border-t border-sage-200 overflow-x-auto">
        {tabs.map((t) => {
          const Icon = t.icon;
          const isActive = active(t);
          return (
            <Link
              key={t.to}
              to={t.to}
              className={`inline-flex items-center gap-1 px-3 py-2 rounded-full text-xs uppercase whitespace-nowrap ${
                isActive ? "bg-sage-500 text-white" : "text-sage-700 bg-white border border-sage-200"
              }`}
            >
              <Icon size={14} />
              {t.label}
            </Link>
          );
        })}
      </nav>
    </header>
  );
};

export default AdminHeader;
